import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

function UnAuthorizedPage() {
  const navigate = useNavigate();
  return (
    <Result
      status="500"
      title="Not Authorized"
      subTitle={
        <pre>
          "You finally broke it. Are you happy now? Just kidding. Looks like you
          don't have correct roles to access this page Contact the administrator
          to get the roles added"
        </pre>
      }
      extra={
        <Button type="primary" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      }
    />
  );
}

export default UnAuthorizedPage;
